import { render, staticRenderFns } from "./zoom-basic-intro-card.vue?vue&type=template&id=9848b3ae&scoped=true"
import script from "./zoom-basic-intro-card.vue?vue&type=script&lang=js"
export * from "./zoom-basic-intro-card.vue?vue&type=script&lang=js"
import style0 from "./zoom-basic-intro-card.vue?vue&type=style&index=0&id=9848b3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9848b3ae",
  null
  
)

export default component.exports